/**
 * `useEnvironment` hook accessing the current environment.
 */
import * as React from "react"
import EnvironmentContext from "../Environment/EnvironmentContext"

const useEnvironment = () => React.useContext(EnvironmentContext)

export default useEnvironment
